import {useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FmlxButton, FmlxDropdown} from 'fmlx-common-ui';
import EssSimpleTable from '../../../components/MessageTable/TableColumn/EssSimpleTable';
import {assignRole, removeAssignEvent, removeNewAssignEvent} from '../../../stores/business/teamAssignmentBusiness';
import { selectIsLoadingTeamAssignment } from '../../../stores/selectors/teamAssignmentSelector';
import Loading from '../../../components/Loading/Loading';


function TableTeamAssignment() {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoadingTeamAssignment)
  const {assignedEmployee, employeeIdToAssign} = useSelector(state => ({
    assignedEmployee: state.teamAssignmentState.assignedEmployee,
    employeeIdToAssign: state.teamAssignmentState.employeeIdToAssign,
  }))
  const columnData = [
    {
      id: 'fullName',
      Header: <div style={{textAlign: 'center'}}>Member Name</div>,
      accessor: 'employee.fullName',
      Cell: ({row}) => <div style={{width: 150}}>{row.original.employee.fullName}</div>,
    },
    {
      id: 'department',
      Header: <div style={{textAlign: 'center'}}>Department</div>,
      accessor: 'employee.practice.department.departmentName',
      Cell: ({row}) => <div
        style={{textAlign: 'center'}}>{row.original.employee.practice.department.departmentName}</div>,
    },
    {
      id: 'role',
      Header: <div style={{textAlign: 'center'}}>Role</div>,
      accessor: 'role',
      Cell: ({row}) => (
        <FmlxDropdown
          size='sm'
          value={row.original.role === 'Team Leader' ? 1 : 2}
          items={[
            {id: 1, text: 'Team Leader', group: 'Role'},
            {id: 2, text: 'Team Member', group: 'Role'},
          ]}
          placeholder={row.original.role}
          onChange={(newValue) => {
            dispatch(assignRole(row.original.id, newValue === 1 ? 'Team Leader' : 'Team Member'));
          }}
        />
      ),
    },
    {
      id: 'joinDate',
      Header: <div style={{textAlign: 'center'}}>Join Date</div>,
      accessor: 'joinDate',
      Cell: ({row}) => <div style={{textAlign: 'center'}}>{row.original.joinDate}</div>,
    },
    {
      id: 'action',
      Header: <div style={{textAlign: 'center'}}>Action</div>,
      accessor: 'action',
      Cell: ({row}) => {
        const isNewMember = employeeIdToAssign.includes(row.original.id);

        return (
          <div style={{display: 'flex', justifyContent: 'center'}}>
            <FmlxButton
              size="small"
              label='Remove'
              onClick={() => {
                if (isNewMember) {
                  dispatch(removeNewAssignEvent(row.original.id));
                } else {
                  dispatch(removeAssignEvent(row.original.id));
                }
              }}
            />
          </div>
        );
      },
      sortable: false,
    },
  ];

  const tableData = useMemo(() => {
    return [...assignedEmployee];
  }, [assignedEmployee]);

  return (
    <>
      {isLoading ? (<Loading/>): (<EssSimpleTable
      columnData={columnData}
      filteredData={tableData}
      dataCount={tableData.length}
      columns={(column, row) => {
        const value = column.Cell ? column.Cell({row: {original: row}}) : row[column.accessor];
        return value;
      }}
      targetValue="team"
      emptyRowHeight={100}
      onEmptyDataShow="No team members found"
      hideFooter={true}
      />
      )}
    </>
    
  );
}


export default TableTeamAssignment;